module.exports = __webpack_public_path__ + "img/m_offline_kiosk_icon_01.png";